import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/search.svg';

export const IconSearch: IconComponent = props => <Icon {...props} src={src} />;
